module.exports = __webpack_public_path__ + "static/media/icon_182.956b63c2.svg";